import { useState, useEffect } from "react";
import React from "react";
function generateKey() {
  return crypto.subtle.generateKey(
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt", "decrypt"]
  );
}

async function encryptMessage(message, key) {
  const encoder = new TextEncoder();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    encoder.encode(message)
  );

  const exportedKey = await crypto.subtle.exportKey("raw", key);
  return {
    data: btoa(
      JSON.stringify({
        iv: Array.from(iv),
        content: Array.from(new Uint8Array(encrypted)),
      })
    ),
    key: btoa(String.fromCharCode(...new Uint8Array(exportedKey))),
  };
}

function createNewMessage() {
  window.location.href = "/app/privatebin";
}

async function decryptMessage(encodedData, base64Key) {
  const decoded = JSON.parse(atob(encodedData));
  const iv = new Uint8Array(decoded.iv);
  const content = new Uint8Array(decoded.content);
  const rawKey = Uint8Array.from(atob(base64Key), (c) => c.charCodeAt(0));

  const key = await crypto.subtle.importKey(
    "raw",
    rawKey,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    content
  );

  return new TextDecoder().decode(decrypted);
}




export const PrivateBinApp: React.FC = () => {
  const [input, setInput] = useState("");
  const [outputUrl, setOutputUrl] = useState("");
  const [decrypted, setDecrypted] = useState("");
  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!hash) return;

    const [data, key] = decodeURIComponent(hash).split("|");
    if (data && key) {
      decryptMessage(data, key)
        .then(setDecrypted)
        .catch(() => setDecrypted("Failed to decrypt or bad key."));
    }
  }, []);
  async function handleEncrypt() {
    const key = await generateKey();
    const { data, key: exportedKey } = await encryptMessage(input, key);
    const encoded = encodeURIComponent(`${data}|${exportedKey}`);
    setOutputUrl(`${window.location.origin}${window.location.pathname}#${encoded}`);
  }
  
  return (
    <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
      {decrypted ? (
        <div>
          <h2>🔓 Decrypted Message:</h2>
          <div
          style={{
            backgroundColor: "#f8f8f8",
            padding: "15px",
            borderRadius: "6px",
            whiteSpace: "normal",
            wordBreak: "break-word",
            fontSize: "16px",
            lineHeight: "1.5",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            color: "#333",
          }}
        >
          {decrypted}
        </div>
        <button
          onClick={createNewMessage}
          style={{
            padding: "12px 20px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "none",
            backgroundColor: "#2a9d8f",
            color: "#fff",
            cursor: "pointer",
            transition: "background-color 0.3s ease, box-shadow 0.3s ease",
            boxShadow: "0 4px 6px rgba(42, 157, 143, 0.5)",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = "#21867a";
            e.currentTarget.style.boxShadow = "0 6px 10px rgba(33, 134, 122, 0.7)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = "#2a9d8f";
            e.currentTarget.style.boxShadow = "0 4px 6px rgba(42, 157, 143, 0.5)";
          }}
          onFocus={e => {
            e.currentTarget.style.outline = "none";
            e.currentTarget.style.boxShadow = "0 0 0 3px rgba(42, 157, 143, 0.6)";
          }}
          onBlur={e => {
            e.currentTarget.style.boxShadow = "0 4px 6px rgba(42, 157, 143, 0.5)";
          }}
        >
          Write a message
        </button>

        </div>
        
      ) : (
        <>
          <h2>🔐 Encrypt & Share</h2>
          <textarea
            rows={6}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Write here..."
            style={{
              width: "100%",
              padding: "12px 15px",
              fontSize: "16px",
              borderRadius: "8px",
              border: "1.5px solid #ccc",
              boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
              outline: "none",
              resize: "vertical",
              transition: "border-color 0.2s ease",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            }}
            onFocus={e => (e.target.style.borderColor = "#007bff")}
            onBlur={e => (e.target.style.borderColor = "#ccc")}
          />
          <br />
          <button
            onClick={handleEncrypt}
            style={{
              marginTop: "12px",
              marginBottom: "12px",
              padding: "12px 20px",
              fontSize: "16px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#2a9d8f",
              color: "#fff",
              cursor: "pointer",
              transition: "background-color 0.3s ease, box-shadow 0.3s ease",
              boxShadow: "0 4px 6px rgba(0, 123, 255, 0.4)",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "#21867a"; // darker shade on hover
              e.currentTarget.style.boxShadow = "0 6px 10px rgba(33, 134, 122, 0.7)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "#2a9d8f";
              e.currentTarget.style.boxShadow = "0 4px 6px rgba(42, 157, 143, 0.5)";
            }}
            onFocus={e => {
              e.currentTarget.style.outline = "none";
              e.currentTarget.style.boxShadow = "0 0 0 3px rgba(42, 157, 143, 0.6)";
            }}
            onBlur={e => {
              e.currentTarget.style.boxShadow = "0 4px 6px rgba(42, 157, 143, 0.5)";
            }}
            >
            Generate Shareable Link
          </button>
          {outputUrl && (
            <div>
              <h4>🔗 Share this link:</h4>
              <a target="_blank" rel="noreferrer" href={outputUrl}>{outputUrl}</a>
            </div>
          )}
        </>
      )}
    <br />
    <div
      style={{
        backgroundColor: "#d1f0e0",
        border: "1.5px solid #2a9d8f",
        color: "#264653",
        padding: "12px 16px",
        borderRadius: "8px",
        marginBottom: "20px",
        fontSize: "15px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        boxShadow: "0 2px 5px rgba(42, 157, 143, 0.3)",
      }}
    >
      <strong>🔒 Your message is private and secure!</strong><br />
      All encryption and decryption happen right here in your browser.<br />
      Your message is <em>never stored on any server</em> it lives only inside the encrypted link you share.
    </div>

    </div>
  );
};

export default PrivateBinApp;